import { Box, Typography, useTheme } from "@mui/material"
import { Carousel, CarouselItem } from "components/Carousel"
import { useTranslation } from "providers/i18n"
import { ATTRACTION_TYPE } from "extensions/iconsiam/constants"
import { usePost } from "hooks/post/usePost"
import { useNavigate } from "react-router-dom"
import { useCallback } from "react"
import { LeftToRightWrapper } from "components/LeftToRightWrapper"

const AttractionButton = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { hasData, postData: attractions } = usePost(ATTRACTION_TYPE)
  const theme = useTheme()
  const { root, carousel, carouselItem, image, attractionText } =
    theme.components?.[`AttractionButton`].styleOverrides || {}

  const handleClick = useCallback(() => {
    navigate("/attractions")
  }, [navigate])

  return (
    <LeftToRightWrapper>
      {hasData && (
        <Box sx={root} onClick={handleClick}>
          <Carousel
            options={{
              type: "fade",
              rewind: true,
              autoplay: true,
              pagination: false,
              interval: 3000,
              arrows: false,
              speed: 1500,
              padding: 4,
            }}
            sx={carousel}
          >
            {attractions.map((attraction) => {
              return (
                <CarouselItem key={attraction.id} sx={carouselItem}>
                  <Box
                    sx={image}
                    component="img"
                    src={attraction?.properties?.feature_image}
                  />
                </CarouselItem>
              )
            })}
          </Carousel>
          <Typography sx={attractionText}>{t("Attractions")}</Typography>
        </Box>
      )}
    </LeftToRightWrapper>
  )
}
export default AttractionButton
